import IShip from "@/models/ship";
import RESTApiEndPoints from "./rest-api-end-points";
import IErrorResponse from "@/models/ErrorResponse";
import axiosService from "@/services/axios-service";
import IMaritimeStandardsResponse from "@/models/IMaritimeStandardsResponse";
import ISearchRequest from "@/models/SearchRequest";
import IShipArea from "@/models/msca/IShipArea";
import { AxiosResponse } from "axios";
import { IPermission } from "@/models/IPermission";

export default class ShipsService {
  public static isError(response: IShip[] | IErrorResponse): response is IErrorResponse {
    return (response as IErrorResponse).errorId !== undefined;
  }

  public async getShips() {
    return axiosService.get<IShip[]>(RESTApiEndPoints.shipsUrl());
  }

  public async getById(id: number) {
    const response = await axiosService.get<IShip>(`${RESTApiEndPoints.shipsUrl()}/${id}`);
    return response.data;
  }

  public async getByIdFull(id: number) {
    const response = await axiosService.get<IShip>(`${RESTApiEndPoints.shipsUrl()}/full/${id}`);
    return response.data;
  }

  public async delete(shipId: number) {
    const response = await axiosService.delete(`${RESTApiEndPoints.shipsUrl()}/${shipId}`);
    return response;
  }

  public async GetShipAreas(id: number): Promise<IShipArea[]> {
    const response: AxiosResponse<IShipArea[]> = await axiosService.get<IShipArea[]>(
      `${RESTApiEndPoints.shipsUrl()}/GetShipAreas/${id}`
    );
    return response.data;
  }
  public async GetPermission(id: number): Promise<IPermission> {
    const response: AxiosResponse<IPermission> = await axiosService.get<IPermission>(
      `${RESTApiEndPoints.shipsUrl()}/GetPermissions/${id}`
    );
    return response.data;
  }
  public async GetMachineryCompartmentsByShipAreaId(id: number) {
    const response = await axiosService.get<IShip[]>(
      `${RESTApiEndPoints.shipsUrl()}/GetMachineryCompartmentsByShipAreaId/${id}`
    );
    return response.data;
  }
  public async getMaritimeStandards(shipId?: number): Promise<IMaritimeStandardsResponse[]> {
    const response = await axiosService.get<IMaritimeStandardsResponse[]>(
      `${RESTApiEndPoints.shipsUrl()}/getMaritimeStandards?shipId=${shipId ?? ""}`
    );
    return response.data;
  }
  public async update(obj: IShip) {
    return axiosService.put(`${RESTApiEndPoints.shipsUrl()}`, obj);
  }
}
